import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	mode: "history",
	routes: [
    {
      path: '/',
      name: 'home',
      component: r=>require(['../pages/home'],r)
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: r=>require(['../pages/aboutus'],r)
    },
    {
      path: '/join',
      name: 'join',
      component: r=>require(['../pages/join'],r)
    },
    {
      path: '/contact',
      name: 'contact',
      component: r=>require(['../pages/contact'],r)
    },
    {
      path: '/jz',
      name: 'jz',
      component: r=>require(['../pages/jz'],r)
    },
    {
      path: '/yh',
      name: 'yh',
      component: r=>require(['../pages/yh'],r)
    },
    {
      path: '/fc',
      name: 'fc',
      component: r=>require(['../pages/fc'],r)
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: r=>require(['../pages/recharge'],r)
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: r=>require(['../pages/protocol'],r)
    }
  ]
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    };
    next();
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js